import React from 'react';

const ProcessingOptions = ({ formData, onFormChange }) => {
  return (
    <div className="form-card">
      <div className="card-header">
        <h3>⚙️ Processing Options</h3>
      </div>
      <div className="card-content">
        <div className="option-toggle">
          <label className="modern-checkbox">
            <input
              type="checkbox"
              checked={formData.annotatedImages}
              onChange={(e) => onFormChange('annotatedImages', e.target.checked)}
            />
            <span className="checkbox-custom"></span>
            <div className="checkbox-content">
              <span className="checkbox-title">Generate Annotated Images</span>
              <span className="checkbox-desc">
                Create visual annotations showing extracted data points
              </span>
            </div>
          </label>
          
          {formData.annotatedImages && (
            <div className="warning-banner">
              <span className="warning-icon">⚠️</span>
              <span>This will cost more than normal processing</span>
            </div>
          )}
        </div>
        <div className="option-toggle">
          <label className="modern-checkbox">
            <input
              type="checkbox"
              checked={formData.processAllPages}
              onChange={(e) => onFormChange('processAllPages', e.target.checked)}
            />
            <span className="checkbox-custom"></span>
            <div className="checkbox-content">
              <span className="checkbox-title">Extract from all document pages</span>
              <span className="checkbox-desc">
                Use this for order confirmations or supplier documents where key fields are not invoice pages
              </span>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ProcessingOptions;
